import React, { useEffect, useRef } from 'react';
import  './wordRain.css';

const WordRain = () => {

  const wordRef = useRef(null);


  let intervalid;



  useEffect(() => {
const rainContainer = document.getElementById("rain-container");

// List of words to "rain" maybe move this to backend 
const words = [
  "Dream", "Code", "Create", "Build", "Design", "Develop", "Debug", "Engineer",
  "Analyze", "Secure", "Innovate", "Optimize", "Strategize", "Research", "Test",
  "Collaborate", "Lead", "Mentor", "Organize", "Manage", "Document", 
  "Communicate", "Visualize", "Prototype", "Implement", "Streamline", 
  "Configure", "Integrate", "Refactor", "Problem Solving", "Adapt", "Support", 
  "Automate", "Plan", "Troubleshoot", "Modernize", "Scale", "Configure", 
  "Engineer Solutions", "Protect Data", "Enhance", "Debug Systems", 
  "Enable Growth", "Improve Processes", "Explore Trends", "Share Knowledge", 
  "Innovate Tools", "Secure Applications", "Build Interfaces", "Analyze Data",
  "Migrations", "AWS", "React", "JavaScript", "PHP", "HTML",
  "CSS", "Nginx", "Docker", "Kubernetes", "Git", "Zustand", "Python",
  "Raspberry Pi", "Linux", "Windows", "ServiceNow", "Active Directory", 
  "Drupal", "Angular", "Frontend Development", "Backend Development",
  "Cybersecurity", "CASP+", "Security+", "Firewall", 
  "DNS Management", "SQL", "Database Design", "UI/UX", "Cloud", 
  "System Administration", "Network Configuration", "Content Management", 
  "Project Planning", "Time Management", "Teamwork", "Training", "Performance Monitoring",
  "Risk Assessment", "Incident Response", "User Support", "Process Improvement", 
  "Optimization", "Client Collaboration", "Task Automation", "Problem Resolution", "Team Leadership",
  "System Security", "Vulnerability Management", "Policy Creation", "Ethical Hacking",
  "Penetration Testing", "Data Visualization", "Web Accessibility", "API Integration",
  "RESTful Services", "MVC Frameworks", "Custom Scripts", "Agile Development",
  "Scrum Methodologies", "Software Documentation", "Version Control", "Dependency Management",
  "Package Managers", "Build Automation", "Continuous Integration", "Test Automation",
  "Unit Testing", "Functional Testing", "Deployment Pipeline", "Server Management",
  "Load Balancing", "Performance Tuning", "Error Logging", "Monitoring Systems",
  "Incident Management", "Change Management", "Knowledge Sharing", "Workflows",
  "Digital Transformation", "Technical Writing", "Presentation Skills", "Public Speaking",
  "Requirements Gathering", "Stakeholder Engagement", "Data Analysis", "Business Intelligence",
  "Risk Mitigation", "Change Implementation", "Workforce Training", "Visual Prototyping",
  "Responsive Design", "Scalable Applications", "Optimization", "Cloud Infrastructure",
  "Hybrid Cloud", "Microservices", "Containerization", "Orchestration", "Web Performance",
  "Data Encryption", "Access Control", "Zero Trust", "Password Management", "Software Development",
  "Task Prioritization", "Code Reviews", "Design Reviews", "Project Scoping", "User Experience",
  "System Integration", "Resource Allocation", "Cyber Resilience", "Multi-Factor Authentication",
  "Threat Detection", "Incident Mitigation", "System Redundancy", "Business Continuity",
  "Disaster Recovery", "Real-Time Monitoring", "Knowledge Base Management", "Endpoint Security",
  "System Backups", "Virtualization", "Resource Scaling", "Cross-Platform Development",
  "IT Consulting", "Enterprise Solutions", "Troubleshooting Logs", "Workflow Optimization",
  "Technical Support", "Hardware Integration", "Custom Applications", "Customer Service"
];

const activeWords = []; // array to store list of active elements

// Generate a random word from the list
function getRandomWord() {
  return words[Math.floor(Math.random() * words.length)];
}

// Generate a random position
function getRandomPosition() {
  return Math.random() * 100; // Percentage
}

// Generate a random speed
function getRandomSpeed() {
  return Math.random() * 5 + 2; // Between 2s and 5s
}

// Create a single word element
function createWord() {
  if (activeWords.length < 50) { 
  const wordElement = document.createElement("div");
  wordElement.textContent = getRandomWord();
  wordElement.className = "word";
  wordElement.style.left = `${getRandomPosition()}%`;
  wordElement.style.animationDuration = `${getRandomSpeed()}s`;
  wordElement.style.animationDelay = `${Math.random()}s`;
  rainContainer.appendChild(wordElement);
  activeWords.push(wordElement); // Track the active word
  }

  // Clean up the old words in the array, but there is something wrong here.
  if (activeWords.length > 50) { // Limit the number of active words
    console.log("Cleaning up old words");
    const oldWord = activeWords.shift(); // Remove the first word in the list
    rainContainer.removeChild(oldWord);
  }
}


// Continuously create word elements
//intervalid = setInterval(() => {console.log("Iterate"); createWord}, 1000); ... luis you gotta clean this up. this is still working in the background and we need it to stop 

setInterval(createWord, 1000);
return () => {
  console.log("Cleaning up!!!!!!!");
  clearInterval(createWord);
};
}, []);

  return (
<div id="rain-container"></div>
  );
};

export default WordRain;
